<template>
  <el-dialog title="修改短信号码" append-to-body :close-on-click-modal="false" @close="close" :visible="true" width="460px" style="min-width: 1100px">
    <template slot="title">
      <span>修改短信号码</span>
    </template>
    <div class="dialog-wrapper">
      <!-- <div class="item">
        <span class="item-title">短信测试：</span>
        <el-input size="small" class="input" v-model="mobilPhone"></el-input>
      </div> -->
      <div class="remarks">
        <div>请前往【京东云舟】-【工具】-【短信工具】-【短信签名】中进行修改号码中操作</div>
        <!-- 注：填写测试号码，在测试发送时无需审核短信内容。 -->
        <!-- <div>1、测试短信手机号不受频控限制，最多填写15个，多个之间用英文逗号分隔；</div>
        <div>2、修改完成后立即生效，且测试手机号的修改会应用到全部渠道；</div>
        <div>3、每天修改手机号的次数上限为5次；</div> -->
      </div>
      <div></div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button showDialog="showDialog" style="width: 96px" @click="close">关闭</el-button>
      <!-- <el-button showDialog="showDialog" style="width: 96px" @click="close">取消</el-button>
      <el-button @click="submit" type="primary" style="width: 96px">提交</el-button> -->
    </span>
  </el-dialog>
</template>

<script>
import { updateSuffixMobileById } from "@/api/backstage/messageBill";
export default {
name: '' ,
components: {
},
props:{
  id:{
    type:String,
    default:'',
  },
  testMobiles:{
    type:String,
    default:'',
  }
},
data() {
  return {
    id:"",
    mobilPhone: "",
    mobilPhone2:"",
  }
},
computed: {},
created() {

},
mounted() {
  this.mobilPhone = this.testMobiles;
  this.mobilPhone2 = this.testMobiles
},
methods: {
  close(){
    this.$emit('close');
  },
  //修改手机号码提交按钮
  submit() {
    if (this.mobilPhone == this.mobilPhone2) {
      this.$message.warning("号码重复");
      return;
    }
    updateSuffixMobileById({
      smsTestMobiles: this.mobilPhone,
      id: this.id,
    })
      .then((res) => {
        if (res.code == 1) {
          this.$message.success("修改成功");
          this.$emit('confirm');
        } else {
          this.$message.error(res.message);
        }
      })
      .catch(() => {});
  },
  updataPhone(){

  },
}
}
</script>
<style lang='scss' scoped>
.dialog-wrapper {
  .item {
    margin: 8px 0;
    .item-title {
      width: 200px;
    }
    .input {
      display: inline-block;
      vertical-align: middle;
      width: 330px;
    }
  }
  .remarks {
    margin-top: 20px;
    width: 400px;
    // height: 44px;
    background: #fafafa;
    opacity: 1;
    line-height: 20px;
  }
  .remarksOne {
    padding: 10px;
    margin-top: 20px;
    width: 400px;
    // height: 80px;
    background: #fafafa;
    opacity: 1;
    // line-height: 44px;
    .boxText {
      // float: left;
      margin: -14px 0 0 20px;
    }
    .icon_i {
      display: inline-block;
      // position: absolute;
      width: 14px;
      height: 14px;
      border-radius: 14px;
      background-color: #ffb95e;
      color: #fff;
      font-size: 10px;
      font-weight: bold;
      text-align: center;
      line-height: 14px;
      font-weight: bold;
      // top: 3px;
      // left: 10px;
    }
  }
}
</style>